export const TEMPLATE_AUDIO = {
  breathing:           "/assets/audio/hum-soft.mp3",
  pmr:                 "/assets/audio/hum-soft.mp3",
  focus_anchoring:     "/assets/audio/hum-soft.mp3",
  visualization:       "/assets/audio/helprr-soft-ambient.mp3",
  journaling:          "/assets/audio/helprr-soft-ambient.mp3",
  creative_expression: "/assets/audio/helprr-soft-ambient.mp3",
  grounding:           null, // silent by design — the exercise asks users to listen to their environment
};
